module.exports = __webpack_public_path__ + "northern-marianas-islands.svg?6548ef7d242d8e29bbc34df687698088";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/northern-marianas-islands.svg
// module id = 254
// module chunks = 10